import React from "react";
import * as Constants from "../client20/logic/Constants";

export function DefaultLabel(props) {
  const { id, value, height } = props;
  const lineHeight = height ? (Math.min(height, Constants.DEFAULT_ROW_HEIGHT)) : Constants.DEFAULT_ROW_HEIGHT;

  const labelStyle = {
    lineHeight: lineHeight + "em",
    cursor: "default"
  }

  return (
    <div style={labelStyle} id={id} >
      {value}
    </div>
  );
}